export default "__VITE_ASSET__bf5fe3a1__"